import { styled, Typography } from '@mui/material';

export const EmptyReport = styled(Typography)`
  text-transform: uppercase;
  opacity: 0.5;
  text-align: center;
`;
